import cursorPaginationModule from "../cursorPaginationModule";

const cursorPaginationResource = {
    templateUrls: {
        cursorPagination: "cursor-pagination"
    }
};

cursorPaginationModule.constant("cursorPaginationResource", cursorPaginationResource);
export default cursorPaginationResource;